var zh_TW = {
  "Add Upsell.com to your ": "將 Upsell.com 新增至您的 ",
  "All time": "所有時間",
  "and select": "並選擇",
  "button": "按鈕",
  "Cart drawer page": "購物車抽屜頁面",
  "Cart page": "購物車頁面",
  "Check status": "檢查狀態",
  "Checkout page": "結帳頁面",
  "Click": "點擊",
  "Click on": "點擊",
  "Click the": "點擊",
  "Custom slot": "自訂插槽",
  "Custom slots": "自訂插槽",
  "Custom Slots": "自訂插槽",
  "contact support.": "聯繫客服。",
  "from the right sidebar": "從右側邊欄",
  "Go to your Cart drawer page": "前往您的購物車抽屜頁面",
  "Go to your Cart page": "前往您的購物車頁面",
  "Go to your Checkout page": "前往您的結帳頁面",
  "Go to your Order status page": "前往您的訂單狀態頁面",
  "Go to your Post purchase page": "前往您的購買後頁面",
  "Go to your Product page": "前往您的產品頁面",
  "Go to your Thank you page": "前往您的感謝頁面",
  "items": "項目",
  "in the left sidebar": "在左側邊欄中",
  "Last 12 months": "過去 12 個月",
  "Last 30 days": "過去 30 天",
  "Last 365 days": "過去 365 天",
  "Last 7 days": "過去 7 天",
  "Last 90 days": "過去 90 天",
  "Last month": "上個月",
  "Last year": "去年",
  "Make sure": "確保",
  "Need assistance? Contact our support team for help.": "需要協助？請聯繫我們的支援團隊。",
  "Order status page": "訂單狀態頁面",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "我們的應用程式目前正在進行一些優化，以提升您的體驗。",
  "Post purchase page": "購買後頁面",
  "Product page": "產品頁面",
  "Save": "儲存",
  "Scroll to the bottom and select": "捲動到底部並選擇",
  "Select": "選擇",
  "Success. Please continue.": "成功。請繼續。",
  "Thank you page": "感謝頁面",
  "The Upsell.com team.": "Upsell.com 團隊。",
  "The Upsell.com widget is not placed on ": "Upsell.com 小工具未放置在 ",
  ". Please follow the steps above or ": " 上。請按照上述步驟操作或 ",
  "Today": "今天",
  "toggle is on": "開關已開啟",
  "Total": "總計",
  "under": "在",
  "We apologize for any inconvenience caused,": "對於造成的任何不便，我們深感抱歉，",
  "We apologize for any inconvenience caused.": "對於造成的任何不便，我們深感抱歉。",
  "We'll be done in a few minutes!": "我們將在幾分鐘內完成！",
  "We're improving our services!": "我們正在改進我們的服務！",
  "Widget already added": "小工具已新增",
  "Yesterday": "昨天",
  "You placed the widget on the ": "您已將小工具放置在 ",
  ", but you didn't save it in Shopify editor. Please go back to ": " 上，但您沒有在 Shopify 編輯器中儲存。請返回 ",
  " and save the changes.": " 並儲存變更。"
};

export { zh_TW as default };
//# sourceMappingURL=zh-TW.json.js.map
